import { css } from '@emotion/react';
import styled from '@emotion/styled';

export default function ErrorText({ error }: { error: string }) {
  return <Error>{error}</Error>;
}

const Error = styled.div`
  ${({ theme }) => css`
    display: block;
    margin-top: 3px;
    ${theme.fontStyle.text.caption_regular}
    color: ${theme.themeColor.negative};
  `}
`;
